import { render } from "./module2.vue?vue&type=template&id=775af0ee&scoped=true"
const script = {}

import "./module2.vue?vue&type=style&index=0&id=775af0ee&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775af0ee"]])

export default __exports__